(function() {
    class CustomerAddresses extends HTMLElement {
      constructor() {
        super();
        this.modal = this.querySelector('[data-modal]');
        this.form = this.querySelector('[data-address-form]');
        this.modalTitle = this.querySelector('[data-modal-title]');
        this.addressIdInput = this.querySelector('[data-address-id-input]');
        this.methodInput = this.querySelector('[data-method-input]');
      }

      connectedCallback() {
        this.setupEventListeners();
      }

      setupEventListeners() {
        this.querySelector('[data-action="add"]').addEventListener('click', () => {
          this.openModal('add');
        });

        this.querySelectorAll('[data-action="edit"]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const addressId = e.target.dataset.addressId;
            this.openModal('edit', addressId);
          });
        });

        this.querySelectorAll('[data-action="set-default"]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const addressId = e.target.dataset.addressId;
            this.setDefaultAddress(addressId);
          });
        });

        this.querySelectorAll('[data-action="delete"]').forEach(btn => {
          btn.addEventListener('click', (e) => {
            const addressId = e.target.dataset.addressId;
            if (confirm('Are you sure you want to delete this address?')) {
              this.deleteAddress(addressId);
            }
          });
        });

        this.querySelector('[data-close-modal]').addEventListener('click', () => {
          this.closeModal();
        });

        this.modal.addEventListener('click', (e) => {
          if (e.target === this.modal) {
            this.closeModal();
          }
        });
      }

      openModal(mode, addressId = null) {
        this.form.reset();

        if (mode === 'add') {
          this.modalTitle.textContent = 'Add Address';
          this.addressIdInput.value = '';
          this.methodInput.value = 'post';
          this.form.action = '/account/addresses';
        } 
        else if (mode === 'edit' && addressId) {
          this.modalTitle.textContent = 'Edit Address';
          this.addressIdInput.value = addressId;
          this.methodInput.value = 'put'; // ✅ CRITICAL
          this.form.action = '/account/addresses/' + addressId;
          this.populateForm(addressId);
        }

        this.modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }

      closeModal() {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
      }

      populateForm(addressId) {
        const card = this.querySelector(`.customer-addresses__card[data-address-id="${addressId}"]`);
        console.log(card)
        if (!card) return;

        this.form.querySelector('[data-first-name]').value = card.dataset.firstName || '';
        this.form.querySelector('[data-last-name]').value = card.dataset.lastName || '';
        this.form.querySelector('[data-address1]').value = card.dataset.address1 || '';
        this.form.querySelector('[data-address2]').value = card.dataset.address2 || '';
        this.form.querySelector('[data-city]').value = card.dataset.city || '';
        this.form.querySelector('[data-province]').value = card.dataset.province || '';
        this.form.querySelector('[data-zip]').value = card.dataset.zip || '';
        this.form.querySelector('[data-phone]').value = card.dataset.phone || '';
        this.form.querySelector('[data-country]').value = card.dataset.country || '';

        this.form.querySelector('[data-default-checkbox]').checked =
          card.classList.contains('is-default');
      }

      setDefaultAddress(addressId) {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = `/account/addresses/${addressId}`;

        const method = document.createElement('input');
        method.type = 'hidden';
        method.name = '_method';
        method.value = 'put';

        const defaultInput = document.createElement('input');
        defaultInput.type = 'hidden';
        defaultInput.name = 'address[default]';
        defaultInput.value = '1';

        const formType = document.createElement('input');
        formType.type = 'hidden';
        formType.name = 'form_type';
        formType.value = 'customer_address';

        const utf8 = document.createElement('input');
        utf8.type = 'hidden';
        utf8.name = 'utf8';
        utf8.value = '✓';

        const returnTo = document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.value = '/account/addresses';

        form.append(method, defaultInput, formType, utf8, returnTo);
        document.body.appendChild(form);
        form.submit();
      }



      deleteAddress(addressId) {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/account/addresses/' + addressId;
        
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = '_method';
        input.value = 'delete';
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
      }
    }

    customElements.define('customer-addresses', CustomerAddresses);
  })();